export default "__VITE_ASSET__9ut8ACfG__"